import { useQuery } from '@tanstack/react-query'

import { useQueryWithStorage } from '@hooks/useQueryWithStorage'

import { useAuthenticatedUser } from '../../../auth/hooks/useAuthenticatedUser'
import {
  initialState,
  searchActiviteiten,
} from '../services/searchActiviteiten'

import { useActiviteitenSearchStore } from './useActiviteitenSearchStore'

export { useActiviteitenSearch, queryKey }

const queryKey = 'activiteiten'

const useQueryStore = () => {
  const { query, storeQuery } = useActiviteitenSearchStore()

  return useQueryWithStorage({
    initialState: initialState,
    query,
    storeQuery,
    queryKey,
  })
}

const useActiviteitenSearch = () => {
  const { onChangeFilters, onReset, query, onChangePage, onChangeSort } =
    useQueryStore()
  const { hasPermissions } = useAuthenticatedUser()

  const { data, refetch, isFetching, isError } = useQuery({
    queryKey: [queryKey, query],
    queryFn: () => searchActiviteiten({ query }),
    enabled: hasPermissions,
    refetchOnMount: true,
  })

  return {
    data: data || initialState.data,
    isLoading: isFetching,
    isError,
    filters: query.filters,
    sort: query.sort,
    initialFilters: initialState.query.filters,
    onChangeFilters,
    onChangeSort,
    onReset,
    onRefresh: refetch,
    onChangePage,
  }
}
